<div [ngStyle]="{'background-image': 'url(' + backgroundImage + ')'}" class="login-container">
  <form (ngSubmit)="onSubmit()" [formGroup]="loginForm" class="login-form">
    <img alt="music-work-logo" src="/assets/login_logo.svg">
    <fieldset>
      <legend translate>login.label</legend>
      <div>
        <label for="login-input" translate>login.username</label>
        <input [placeholder]="'login.username' | translate" formControlName="username" id="login-input" name="username"
               required type="text"/>
      </div>
      <div>
        <label for="login-password" translate>login.password</label>
        <input [placeholder]="'login.password' | translate" formControlName="password" id="login-password"
               name="password"
               required type="password"/>
      </div>
    </fieldset>
    <div class="form-bottom">
      <input formControlName="rememberMe" id="remember-me" name="remember-me" type="checkbox"/>
      <label for="remember-me" translate>login.rememberMe</label>
      <button class="rounded-button red" id="login-submit" translate type="submit">login.label</button>
    </div>
    <a (click)="openHelpPopup()" [title]="'login.forgotten' | translate" class="forgotten-password"
       translate>login.forgotten</a>
    <div class="version">v{{currentApplicationVersion}}</div>
  </form>
</div>
